/**
 * Mooring posts and reeds along the west quay foot (lifted from lantern-water's
 * `world.js` `createTown`: "river reeds, mooring posts"): a post every 1.4 from
 * z 4 to 10 at x 4.3, each with four reed stems leaning out of the water.
 * Placed at the origin (the town's points). Its own random stream. No params.
 */
import * as THREE from 'three';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'river_reeds',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { cylinder, line, random, m } = ctx;
    for (let z = 4; z < 10; z += 1.4) {
      cylinder(root, 4.3, -0.4, z, 0.1, 1.6, m.wood);
      for (let k = 0; k < 4; k += 1) line(root, [4.25, -0.7, z], [4.5 + random() * 0.3, 0.4 + random() * 0.4, z + random() * 0.4], 0.025, m.moss);
    }
    return { root };
  },
};
